import AmpersandCollection from 'ampersand-collection'
import ProjectUser from './project-user-basic'

const ProjectUsers = AmpersandCollection.extend({
    model: ProjectUser,

    // New

    // experimental
    notClients(projectId) {
        return new ProjectUsers(this.filter(projectUser=>projectUser.project.id === projectId && projectUser.access && projectUser.access !== gd.const.project.access.CLIENT),{parse:false}).models;
    },

    clients(projectId) {
        return new ProjectUsers(this.filter(projectUser=>projectUser.project.id === projectId && projectUser.access === gd.const.project.access.CLIENT),{parse:false}).models;
    },



    //


    countByProject(projectId) {

        return this.filter(m=>m.project.id === projectId).length;

    },

    getByProject(projectId) {
        return this.filter(m=>m.project.id === projectId).map(pu=>pu.user.id);
    },

    filterByCompany(companyId) {
        return new ProjectUsers(this.filter(m=>m.project.companyId === companyId),{parse:false});
    },

    filterByProject(projectId, minAccess) {
        return new ProjectUsers(this.filter(m=>m.project.id === projectId && m.access && (!minAccess || m.access >= minAccess)),{parse:false});
    },

    filterByProjectNotReadOnly(projectId) {
        const setAccess = new Set([gd.const.project.access.FULL, gd.const.project.access.STANDARD, gd.const.project.access.LIMITED]);
        return new ProjectUsers(this.filter(m=>m.project.id === projectId && setAccess.has(m.access)),{parse:false});
    },

    filterByProjects(projectIds) {
        return new ProjectUsers(this.filter(m => m.access && projectIds.indexOf(m.project.id) > -1), {parse:false});
    },

    filterByUser(userId, minAccess) {
        return new ProjectUsers(this.filter(m=>m.user.id === userId && (!minAccess || m.access >= minAccess)),{parse:false});
    },

    filterByUserAndRole(userId, projectRole) {
        return new ProjectUsers(this.filter(m=>m.user.id === userId && m.projectRole >= projectRole),{parse:false});
    },

    findProjectManager() {
        let pu = false;
        this.models.map(m=>{
            if (m.projectRole === gd.const.project.role.PROJECT_MANAGER) {
                pu = m;
            }
        });
        return pu;
    },

    findProjectOwner() {
        let po = false;
        this.models.map(m=>{
            if (m.projectRole === gd.const.project.role.OWNER) {
                po = m;
            }
        });
        return po;
    },

    exportToOptions() {
        const result = [];
        this.models.map(m=>{
            result.push({
                value: m.user.id,
                label: m.user.name,
                icon: m.user.icon,
                iconObj: m.user
            })
        });

        return result;
    },

    exportToArrayUserId() {
        return this.map(function(pu){
            return pu.user.id;
        });
    },

    resetAndKeepOldModels(data, options = {}) {
        const previousCollectionModels = _.clone(this.models)

        if (options.companyId) {
            this.resetByCompany(options.companyId, data)
        } else if (options.projectId) {
            this.resetByProject(options.projectId, data, options.silent)
        } else {
            this.reset(data, {parse:true})
        }

        // add models that are missing in new session Collection
        // and mark as no access in order not to appear in project users lists
        _.map(previousCollectionModels, model => {
            if (!this.get(model.id)) {
                model.access = null
                this.add(model)
            }
        })
    },

    resetByProject(projectId,data, silent=false) {
        const sessionProject = gd.session.projects.get(projectId);
        if (!sessionProject || sessionProject.isTemplate) return; // no users for template projects

        const oldUsersArr = this.filter(projectUser=>projectUser.project.id === projectId);
        _.each(oldUsersArr,model=>{this.remove(model,{ silent: true })});

        //temporary fix to remove users for projects not present in gd.session.projects - THIS IS NEED FIX as pu relays on project model...
        const newData = _.remove(data.slice(), data=>gd.session.projects.get(data.projectId) != null);
        this.add(newData,{ parse: true, silent: true });

        // we keep access in session.projectUsers & session.projects ... so when update project Users need update project.access
        // for self user

        _.map(data, projectUser=>{
            if (gd.session.me.id === projectUser.userId &&
                sessionProject &&
                sessionProject.id === projectUser.projectId &&
                sessionProject.access !== projectUser.access) {
                sessionProject.access = projectUser.access
            }
        })

        if (!silent) this.trigger("reset");
    },

    resetByCompany(companyId,newData) {
        const oldUsersArr = this.filter(projectUser=>projectUser.project.companyId === companyId);
        _.each(oldUsersArr,model=>{this.remove(model,{ silent: true })});

        //temporary fix to remove users for projects not present in gd.session.projects
        newData = _.remove(newData, data=>gd.session.projects.get(data.projectId) != null);

        this.add(newData,{ parse: true, silent: true });
        this.trigger("reset");
    },

    findByProjectAndUser(projectId, userId) {

        // new - old code super slow when lots of checks
        return this.get(projectId+"-"+userId)

        // OLD
        // var result = null;
        //
        // this.map(function(projectUser){
        //     if (projectUser.user.id === userId && projectUser.project.id === projectId) {
        //         result = projectUser;
        //         return false;
        //     }
        // });
        //
        // return result;
    }

});

module.exports = ProjectUsers;